import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'

import Header from '@/components-latest/layout/Header'
import Spinner from '@/components-latest/primitives/Spinner'
import Text from '@/components-latest/primitives/Text'
import CampaignsTable from '@/components-latest/ui/CampaignsPage/CampaignsTable'
import EmptyCampaignsPage from '@/components-latest/ui/CampaignsPage/EmptyCampaignsPage'
import { useFetchCampaignsQuery } from '@/ducks/campaigns/api/campaigns.api'
import type { CampaignLimit } from '@/ducks/campaigns/campaigns.types'

import Styles from './MarketingCampaignsPage.module.scss'

const MarketingCampaignsPage = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState<CampaignLimit>(20)

  const { data, isFetching, isError } = useFetchCampaignsQuery({ page, limit })

  const handleLimitChange = (nextLimit: CampaignLimit) => {
    setLimit(nextLimit)
    setPage(0)
  }

  return (
    <div className={Styles.page}>
      <Header title={t('marketing.campaigns.title')} />

      <div className={Styles.content}>
        <Text variant="heading-04" weight="semiBold" className={Styles.sectionTitle}>
          {t('marketing.campaigns.offers-section')}
        </Text>

        {match({ isFetching, isError, data })
          .when(
            ({ isFetching, data }) => isFetching && !data,
            () => (
              <div className={Styles.spinner}>
                <Spinner />
              </div>
            )
          )
          .when(
            ({ isError }) => isError,
            () => <EmptyCampaignsPage />
          )
          .when(
            ({ data }) => !data?.campaigns?.length,
            () => <EmptyCampaignsPage />
          )
          .otherwise(({ data }) => (
            <CampaignsTable
              campaigns={data!.campaigns}
              page={data!.page}
              limit={data!.limit as CampaignLimit}
              total={data!.total}
              onPageChange={setPage}
              onLimitChange={handleLimitChange}
            />
          ))}
      </div>
    </div>
  )
}

export default MarketingCampaignsPage
